/**
 * Allowed remittance state transitions.
 *
 * This is the canonical state machine for remittance threads.
 * Use it to validate transitions and to build audits/visualizations.
 */
export const REMITTANCE_STATE_TRANSITIONS = {
    new: ['identityRequested', 'invoiced', 'settled', 'terminated', 'errored'],
    identityRequested: ['identityResponded', 'identityAcknowledged', 'invoiced', 'settled', 'terminated', 'errored'],
    identityResponded: ['identityAcknowledged', 'invoiced', 'settled', 'terminated', 'errored'],
    identityAcknowledged: ['invoiced', 'settled', 'terminated', 'errored'],
    invoiced: ['identityRequested', 'identityResponded', 'identityAcknowledged', 'settled', 'terminated', 'errored'],
    settled: ['receipted', 'terminated', 'errored'],
    receipted: ['terminated', 'errored'],
    terminated: ['errored'],
    errored: []
};
export const SAT_UNIT = { namespace: 'bsv', code: 'sat', decimals: 0 };
//# sourceMappingURL=types.js.map